import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { fetchScheduledJobStatus } from '~/features/content-enrichment/services/scheduled-enrichment.service';
import type { ScheduledJobStatusResponse } from '~/features/content-enrichment/types/scheduled-enrichment.types';

/**
 * Fetches the scheduled-enrichment aggregate status (`GET /scheduled/jobs/{jobId}/status`)
 * for a catalog batch so the detail page can surface per-kind preview failures
 * (content scoring / sample enrichment) even when the parent status rolled up to
 * COMPLETED — an empty data source now FAILS a preview while a re-run pipeline can
 * still deliver. Keyed off the workflow slug (`header.batchId`), NOT the job-uuid
 * route param, which 404s the status endpoint. `enabled` gates it to funnel batches.
 */
export function useScheduledJobStatus(workflowId: string, enabled: boolean) {
  return useQuery<ScheduledJobStatusResponse>({
    queryKey: queryKeys.scheduledEnrichment.jobStatus(workflowId),
    queryFn: () => fetchScheduledJobStatus(workflowId),
    enabled: enabled && !!workflowId,
    staleTime: 30_000,
  });
}
